import React, { PureComponent } from 'react';
import Wizard, { WizardStep, withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import ReviewAndFinalizeStep from './ReviewAndFinalizeStep/ReviewAndFinalizeStep';
import CreatingContractStep from './CreatingContractStep/CreatingContractStep';
import ResultStep from './ResultStep/ResultStep';

const REVIEW_AND_FINALIZE_STEP = 'review-and-finalize';
const CREATING_CONTRACT_STEP = 'create-term';
const RESULT_STEP = 'result';

class ReviewPage extends PureComponent {
  static defaultProps = {};

  static propTypes = {};

  state = {
    active: REVIEW_AND_FINALIZE_STEP,
    latest: REVIEW_AND_FINALIZE_STEP
  };

  onChangeStep = (active, latest, previous, next) => {
    this.setState({ active });
    this.setState({ latest });
  };

  onPreviousParentWizard = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.previous);
  };

  render() {
    const { flow, onChange, wizard } = this.props;

    return (
      <Wizard active={this.state.active} latest={this.state.latest} hideStepper={true} onChangeStep={this.onChangeStep}>
        <WizardStep name={REVIEW_AND_FINALIZE_STEP} title="Review and Finalize">
          <ReviewAndFinalizeStep onPrev={this.onPreviousParentWizard} flow={flow} onChange={onChange} />
        </WizardStep>
        <WizardStep name={CREATING_CONTRACT_STEP} title="Review and Finalize">
          <CreatingContractStep flow={flow} onChange={onChange} />
        </WizardStep>
        <WizardStep name={RESULT_STEP} title="Review and Finalize">
          <ResultStep parentWizard={wizard} flow={flow} onChange={onChange} />
        </WizardStep>
      </Wizard>
    );
  }
}

// withWizard to get the parent's flows
export default withWizard(ReviewPage);
